import { useEffect, useState } from 'react';

/**
 * Global rule 4 -- search-as-you-type, without a request per keystroke.
 *
 * `term` drives the input (responsive, updates synchronously on every
 * keystroke); `debouncedTerm` drives the query and only changes once the
 * caller has stopped typing for `delayMs`.
 */
export function useDebouncedSearch(initial = '', delayMs = 300) {
  const [term, setTerm] = useState(initial);
  const [debouncedTerm, setDebouncedTerm] = useState(initial);

  useEffect(() => {
    const id = setTimeout(() => setDebouncedTerm(term), delayMs);
    return () => clearTimeout(id);
  }, [term, delayMs]);

  return { term, debouncedTerm, setTerm };
}
